// extracted by mini-css-extract-plugin
export default {"desktop-root":"FloatingQuote_desktop-root__J55cv","container":"FloatingQuote_container__TYKRi","floating-box":"FloatingQuote_floating-box__ib5Cl"};